var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_590)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76598 18.3644V11.6276C3.76598 9.04377 5.89005 6.94922 8.47381 6.94922H5.76036C3.17655 6.94922 1.082 9.04377 1.082 11.6276V18.3644C1.082 20.9482 3.17655 23.0428 5.76036 23.0428H8.47381C5.89005 23.0428 3.76598 20.9482 3.76598 18.3644Z",
    fill: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.8361 12.9885C13.2934 12.5306 13.2938 11.7897 12.8371 11.3337C12.3804 10.8777 11.6395 10.8791 11.1823 11.337C10.7251 11.7948 10.7247 12.5357 11.1814 12.9918C11.6381 13.4478 12.3789 13.4463 12.8361 12.9885Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3626 23.9999H5.63744C2.54186 23.9999 0.023407 21.4815 0.023407 18.3859V11.6491C0.023407 8.55349 2.54186 6.03503 5.63744 6.03503H18.3626C21.4582 6.03503 23.9766 8.55349 23.9766 11.6491V18.3859C23.9766 21.4815 21.4582 23.9999 18.3626 23.9999ZM5.63744 7.90638C3.57372 7.90638 1.89475 9.58535 1.89475 11.6491V18.3859C1.89475 20.4496 3.57372 22.1286 5.63744 22.1286H18.3626C20.4263 22.1286 22.1053 20.4496 22.1053 18.3859V11.6491C22.1053 9.58535 20.4263 7.90638 18.3626 7.90638H5.63744Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2926 17.6835H9.70778C6.89595 17.6835 4.60837 15.3959 4.60837 12.5841C4.60837 12.0673 5.02727 11.6484 5.54404 11.6484C6.06081 11.6484 6.47971 12.0673 6.47971 12.5841C6.47971 14.3641 7.92781 15.8122 9.70778 15.8122H14.2926C16.0726 15.8122 17.5206 14.3641 17.5206 12.5841C17.5206 12.0673 17.9395 11.6484 18.4563 11.6484C18.9731 11.6484 19.392 12.0673 19.392 12.5841C19.392 15.3959 17.1044 17.6835 14.2926 17.6835Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5089 4.16374C14.9921 4.16374 14.5732 3.74484 14.5732 3.22807C14.5732 2.48 13.9646 1.87134 13.2165 1.87134H10.7837C10.0356 1.87134 9.42701 2.48 9.42701 3.22807C9.42701 3.74484 9.00811 4.16374 8.49134 4.16374C7.97456 4.16374 7.55566 3.74484 7.55566 3.22807C7.55566 1.44809 9.00376 0 10.7837 0H13.2165C14.9965 0 16.4446 1.44809 16.4446 3.22807C16.4446 3.74484 16.0257 4.16374 15.5089 4.16374Z",
    fill: "#3C3C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon3);
export default __webpack_public_path__ + "static/media/dashboard-icon3.5f220b7394703d7e91ec217e271648c8.svg";
export { ForwardRef as ReactComponent };